// ═══════════════════════════════════════════════════════════════════
//  GUIDE CAPILLAIRE — MAISON TOINON
//  Version v3 — formulaire HTML caché + appel explicite à
//  Shopify.captcha.protect() pour attacher la protection hCaptcha
//  AVANT la soumission (sinon hCaptcha bloque silencieusement).
//  Aucune clé API exposée.
// ═══════════════════════════════════════════════════════════════════
 
const answers = { 1: null, 2: null, 3: null };
 
// ───────────────────────────────────────────────────────────────
//  ILLUSTRATIONS — textures de cheveux dessinées en SVG
// ───────────────────────────────────────────────────────────────
 
function drawHairVisuals() {
  drawCircleTexture("hv-ondule", "ondule");
  drawCircleTexture("hv-boucle", "boucle");
  drawCircleTexture("hv-friso", "friso");
  drawCircleTexture("hv-crepu", "crepu");
}
 
function drawCircleTexture(id, type) {
  const el = document.getElementById(id);
  if (!el) return;
  const S = 110, cx = S / 2, cy = S / 2, r = S / 2 - 1;
  const stroke = "#C97B5A";
  const sw = type === "crepu" ? 1.3 : type === "friso" ? 1.4 : 1.6;
  const ns = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(ns, "svg");
  svg.setAttribute("viewBox", `0 0 ${S} ${S}`);
  svg.setAttribute("width", S);
  svg.setAttribute("height", S);
  const defs = document.createElementNS(ns, "defs");
  const clip = document.createElementNS(ns, "clipPath");
  clip.setAttribute("id", `clip-${id}`);
  const circle = document.createElementNS(ns, "circle");
  circle.setAttribute("cx", cx);
  circle.setAttribute("cy", cy);
  circle.setAttribute("r", r);
  clip.appendChild(circle);
  defs.appendChild(clip);
  svg.appendChild(defs);
  const g = document.createElementNS(ns, "g");
  g.setAttribute("clip-path", `url(#clip-${id})`);
  g.setAttribute("fill", "none");
  g.setAttribute("stroke", stroke);
  g.setAttribute("stroke-width", sw);
  g.setAttribute("stroke-linecap", "round");
  generatePaths(type, S).forEach(d => {
    const p = document.createElementNS(ns, "path");
    p.setAttribute("d", d);
    g.appendChild(p);
  });
  svg.appendChild(g);
  el.appendChild(svg);
}
 
function generatePaths(type, S) {
  const paths = [];
  if (type === "ondule") {
    for (let i = 0; i < 11; i++) {
      const x = 5 + i * (S / 10) * 0.92, amp = 5;
      let d = `M${x},0 `;
      const steps = 12;
      for (let s = 0; s <= steps; s++) {
        const y = s * (S / steps);
        const offset = amp * Math.sin(s / steps * Math.PI * 2 + i * 0.5);
        d += `L${x + offset},${y} `;
      }
      paths.push(d);
    }
  } else if (type === "boucle") {
    for (let i = 0; i < 10; i++) {
      const x0 = 5 + i * (S / 9) * 0.95, amp = 9, freq = 2.5, phase = i * 0.8;
      let d = "";
      const steps = 40;
      for (let s = 0; s <= steps; s++) {
        const t = s / steps, y = t * S;
        const x = x0 + amp * Math.sin(t * Math.PI * freq + phase);
        d += s === 0 ? `M${x},${y} ` : `L${x},${y} `;
      }
      paths.push(d);
    }
  } else if (type === "friso") {
    for (let i = 0; i < 9; i++) {
      const x0 = 5 + i * (S / 8) * 0.92, amp = 5, freq = 6, phase = i * 1.1;
      let d = "";
      const steps = 60;
      for (let s = 0; s <= steps; s++) {
        const t = s / steps, y = t * (S + 4) - 2;
        const x = x0 + amp * Math.sin(t * Math.PI * freq + phase);
        d += s === 0 ? `M${x},${y} ` : `L${x},${y} `;
      }
      paths.push(d);
    }
  } else if (type === "crepu") {
    for (let i = 0; i < 11; i++) {
      const x0 = 4 + i * (S / 10) * 0.92, amp = 3.5, segH = 5;
      let d = `M${x0},0`;
      let y = 0, dir = i % 2 === 0 ? 1 : -1;
      while (y < S) {
        y += segH;
        d += ` L${x0 + amp * dir},${y}`;
        dir *= -1;
      }
      paths.push(d);
    }
  }
  return paths;
}
 
// ───────────────────────────────────────────────────────────────
//  NAVIGATION ENTRE ÉCRANS
// ───────────────────────────────────────────────────────────────
 
function goTo(step) {
  document.querySelectorAll(".screen").forEach(s => s.classList.remove("active"));
  document.getElementById("screen-" + step).classList.add("active");
  updateProgress(step);
  window.scrollTo({ top: 0, behavior: "smooth" });
}
 
function updateProgress(step) {
  document.querySelectorAll(".progress-dot").forEach((d, i) => {
    d.classList.remove("active", "done");
    if (i < step) d.classList.add("done");
    if (i === step && step < 4) d.classList.add("active");
  });
}
 
function selectOption(el) {
  const q = parseInt(el.dataset.q);
  const val = el.dataset.val;
  el.parentElement.querySelectorAll("[data-q]").forEach(c => c.classList.remove("selected"));
  el.classList.add("selected");
  answers[q] = val;
  const btn = document.getElementById("next-" + q);
  if (btn) btn.classList.add("enabled");
}
 
// ───────────────────────────────────────────────────────────────
//  PROFIL CAPILLAIRE
// ───────────────────────────────────────────────────────────────
 
function getProfile() {
  const hair = answers[1], dry = answers[2], poro = answers[3];
  const profile = { label: "", description: "", products: [], routine: [], tips: [], freq: "" };
 
  const needsRich = hair === "crepu" || (hair === "friso" && dry === "tres-seche");
  const hairLabels = { ondule: "Ondulé", boucle: "Bouclé", friso: "Frisé", crepu: "Crépu" };
  const dryLabels = { normal: "équilibré", seche: "sec", "tres-seche": "très sec" };
 
  profile.label = `Cheveux ${hairLabels[hair] || ""} · ${dryLabels[dry] || ""}`;
 
  if (hair === "ondule" || hair === "boucle") profile.freq = "1 à 2 fois par semaine";
  else if (hair === "friso") profile.freq = "1 fois par semaine";
  else profile.freq = "Tous les 7 à 10 jours";
 
  if (needsRich) {
    profile.description = "Vos cheveux ont besoin d'une nutrition intense et régulière. La boucle très serrée empêche le sébum naturel de descendre le long de la tige capillaire — c'est pourquoi ils se dessèchent plus vite que les autres types.";
  } else if (dry === "tres-seche") {
    profile.description = "Une texture qui demande constance et richesse. Votre routine s'articule autour de la nutrition et de l'occlusion.";
  } else {
    profile.description = "Vos cheveux texturés ont besoin de douceur et de nutrition équilibrée. Une routine régulière suffira à les garder définis, brillants et en bonne santé.";
  }
 
  profile.products.push({
    type: "shampoo",
    badge: "Étape 1 — Nettoyage",
    name: "Le Shampoing Doux",
    desc: "Formulé pour tous les cheveux texturés à partir de 3 ans, il nettoie sans dépouiller la fibre capillaire. Sans sulfates agressifs, il préserve le film hydrolipidique naturel de vos cheveux.",
    usage: ["Mousse légère", "Massage doux du cuir chevelu", "Rinçage complet"]
  });
 
  if (needsRich) {
    profile.products.push({
      type: "mask-rich",
      badge: "Étape 2 — Soin intensif",
      name: "Le Masque Enrichi",
      desc: "Conçu spécifiquement pour les cheveux frisés et crépus, ce soin 2-en-1 après-shampoing & masque apporte une nutrition intense grâce à ses actifs concentrés.",
      usage: ["Sur cheveux humides", "Du milieu aux pointes", "Pose 5–20 min sous bonnet"]
    });
  } else {
    profile.products.push({
      type: "mask",
      badge: "Étape 2 — Soin nourrissant",
      name: "Le Masque",
      desc: "Idéal pour les cheveux ondulés et bouclés, il nourrit et démêle en douceur. Son usage en après-shampoing et masque simplifie votre routine sans compromis sur l'efficacité.",
      usage: ["Sur cheveux humides", "Du milieu aux pointes", "Rinçage généreux"]
    });
  }
 
  profile.routine = buildRoutine(hair, dry, poro, needsRich);
  profile.tips = buildTips(hair, dry, poro);
  return profile;
}
 
function buildRoutine(hair, dry, poro, needsRich) {
  const steps = [];
  steps.push({
    num: "01",
    name: "Détressez et démêlez",
    detail: "Avant tout mouillage, démêlez délicatement avec les doigts ou un peigne à larges dents, section par section, des pointes vers les racines."
  });
  steps.push({
    num: "02",
    name: "Pré-poo (optionnel mais recommandé)",
    detail: (hair === "crepu" || hair === "friso")
      ? "Appliquez une huile végétale (coco, olive, jojoba) sur les longueurs 30 min avant le shampoing pour protéger la fibre de l'eau."
      : "Si vos cheveux sont très secs, une huile légère avant le shampoing limitera la perte de protéines lors du mouillage."
  });
  steps.push({
    num: "03",
    name: "Le Shampoing Doux",
    detail: "Mouillez abondamment, appliquez le shampoing directement sur le cuir chevelu. Massez avec les pouces en mouvements circulaires. Laissez l'eau de rinçage nettoyer les longueurs."
  });
  if (needsRich) {
    steps.push({
      num: "04",
      name: "Le Masque Enrichi — pose longue",
      detail: "Appliquez généreusement sur cheveux essorés (éponge les excès d'eau). Couvrez d'un bonnet en plastique, puis d'une serviette chaude. Laissez poser 15 à 30 minutes."
    });
  } else {
    steps.push({
      num: "04",
      name: "Le Masque",
      detail: "Appliquez sur cheveux humides, section par section. Démêlez avec les doigts pendant la pose (5–10 min). Rincez longuement."
    });
  }
  steps.push({
    num: "05",
    name: "Coiffage immédiat",
    detail: "Coiffez toujours sur cheveux encore humides. Définissez vos boucles avec les doigts ou utilisez la méthode « scrunch » pour raviver le volume."
  });
  return steps;
}
 
function buildTips(hair, dry, poro) {
  const tips = [];
 
  if (poro === "elevee") {
    tips.push({
      icon: "🌡️", title: "Eau froide obligatoire",
      text: "Terminez toujours le rinçage à l'eau froide. Ça referme les écailles et scelle l'hydratation à l'intérieur de la fibre.",
      expert: "Vos écailles étant naturellement ouvertes, l'hydratation s'échappe aussi vite qu'elle entre. L'eau froide est votre premier geste occlusif."
    });
    tips.push({
      icon: "🪙", title: "Scellez avec une huile",
      text: "Après le masque, appliquez une fine couche d'huile pour verrouiller l'hydratation. C'est la logique de la méthode LOC.",
      expert: "Ordre LOC — Leave-in → Oil (occlusion) → Cream. Ne l'inversez pas : une huile posée avant le soin bloque l'absorption."
    });
    tips.push({
      icon: "🌿", title: "Glycérine : alliée ou ennemie",
      text: "Par temps humide, la glycérine peut faire gonfler la fibre et créer du frizz. Par temps sec, elle peut pomper l'humidité de vos cheveux.",
      expert: "En hiver ou par faible humidité ambiante, évitez les produits riches en glycérine ou scellez-les immédiatement avec une huile."
    });
  } else if (poro === "faible") {
    tips.push({
      icon: "♨️", title: "Chaleur pour ouvrir",
      text: "Utilisez un bonnet chauffant ou une serviette chaude pendant la pose du masque. Sans chaleur, les actifs restent en surface.",
      expert: "Vos écailles très fermées bloquent la pénétration. La chaleur les entrouvre mécaniquement — c'est la condition pour que le soin fonctionne vraiment."
    });
    tips.push({
      icon: "💦", title: "Hydratez sur cheveux très humides",
      text: "Appliquez vos soins quand les cheveux sont encore gorgés d'eau. La fibre est plus réceptive les écailles légèrement entrouvertes.",
      expert: "L'eau est le seul hydratant réel. Les crèmes et huiles ne font que la retenir — pas la remplacer."
    });
    tips.push({
      icon: "🧹", title: "Évitez la surcharge",
      text: "Votre fibre retient bien l'hydratation mais accumule aussi les résidus. Un shampoing clarifiant une fois par mois évite l'effet « alourdi ».",
      expert: "Les signes d'accumulation : boucles qui se définissent moins, cheveux ternes malgré les soins. Un shampoing sans silicone suffit à repartir sur une base saine."
    });
  } else {
    tips.push({
      icon: "⚖️", title: "Équilibre est la clé",
      text: "Votre porosité est idéale. Misez sur la régularité plutôt que les techniques complexes.",
      expert: "Résistez à la tentation de multiplier les produits. La constance d'une routine simple surpasse n'importe quel « super soin » utilisé ponctuellement."
    });
    tips.push({
      icon: "🔬", title: "Surveillez le ratio protéines / hydratation",
      text: "Cheveux mous et sans ressort = trop d'hydratation. Cheveux cassants et secs = trop de protéines.",
      expert: "Ce déséquilibre est la première cause de boucles qui « ne fonctionnent plus ». Ajustez avant de changer de produits."
    });
  }
 
  if (hair === "crepu" || hair === "friso") {
    tips.push({
      icon: "🧺", title: "Travaillez en sections",
      text: "Divisez vos cheveux en 4 à 8 sections pour chaque étape. C'est la seule façon d'assurer une application uniforme et d'éviter les nœuds.",
      expert: "Plus vos cheveux sont denses, plus les sections doivent être petites. Une application bâclée = zones non nourries = rupture de fibre localisée."
    });
    tips.push({
      icon: "🌿", title: "La méthode GHE pour les nuits sèches",
      text: "Appliquez une huile végétale sur cheveux légèrement humides, couvrez d'un bonnet plastique pour la nuit.",
      expert: "La GHE (Greenhouse Effect) remplace avantageusement le bonnet chauffant électrique. Idéale en hiver quand l'air intérieur est sec."
    });
  } else {
    tips.push({
      icon: "🌙", title: "Protégez la nuit",
      text: "Taie d'oreiller en satin ou bonnet en satin — sans exception. Le coton crée une friction qui casse les boucles et absorbe l'hydratation.",
      expert: "Le satin ne « glisse » pas seulement, il ne capte pas non plus l'humidité de vos cheveux. Sur un an, la différence sur l'état des pointes est visible."
    });
  }
 
  if (dry === "tres-seche") {
    tips.push({
      icon: "🔄", title: "Méthode LOC",
      text: "Après le soin : hydratez avec de l'eau → appliquez le masque → scellez avec une huile légère.",
      expert: "L'ordre est fondamental. L'huile en dernier crée un film occlusif qui empêche l'évaporation de l'eau déjà absorbée."
    });
  } else {
    tips.push({
      icon: "📅", title: "Soin mensuel profond",
      text: "Une fois par mois, appliquez le masque en grande quantité, couvrez d'un bonnet et laissez poser toute la nuit.",
      expert: "Ce soin de nuit compense les agressions du quotidien que la routine hebdomadaire seule ne suffit pas à réparer."
    });
  }
 
  return tips.slice(0, 4);
}
 
// ───────────────────────────────────────────────────────────────
//  AFFICHAGE DU RÉSULTAT
// ───────────────────────────────────────────────────────────────
 
function showResult() {
  const profile = getProfile();
  const html = buildResultHTML(profile);
  document.getElementById("result-content").innerHTML = html;
  goTo(4);
}
 
function buildResultHTML(p) {
  let html = `
    <div class="result-header">
      <div class="result-eyebrow">Votre profil capillaire</div>
      <h2 class="result-title">${p.label}</h2>
      <p class="result-subtitle">${p.description}</p>
    </div>
 
    <div class="products-section">
      <div class="section-label">Vos produits recommandés</div>`;
 
  for (const prod of p.products) {
    html += `
      <div class="product-card ${prod.type}">
        <span class="product-badge">${prod.badge}</span>
        <div class="product-name">${prod.name}</div>
        <div class="product-desc">${prod.desc}</div>
        <div class="product-usage">
          ${prod.usage.map(u => `<span class="usage-pill">· ${u}</span>`).join("")}
        </div>
      </div>`;
  }
 
  html += `</div>
    <div class="routine-section">
      <div class="routine-title">Votre routine — ${p.freq}</div>`;
 
  for (const step of p.routine) {
    html += `
      <div class="routine-step">
        <div class="step-num">${step.num}</div>
        <div class="step-content">
          <div class="step-name">${step.name}</div>
          <div class="step-detail">${step.detail}</div>
        </div>
      </div>`;
  }
 
  html += `</div>
    <div class="section-label" style="margin-top:8px">Conseils pour votre profil</div>
    <div class="tips-section">`;
 
  for (const tip of p.tips) {
    html += `
      <div class="tip-card">
        <div class="tip-icon">${tip.icon}</div>
        <div class="tip-title">${tip.title}</div>
        <div class="tip-text">${tip.text}</div>
        ${tip.expert ? `<div class="tip-expert">→ ${tip.expert}</div>` : ""}
      </div>`;
  }
 
  html += "</div>";
  return html;
}
 
// ───────────────────────────────────────────────────────────────
//  CAPTURE EMAIL — soumission via formulaire HTML caché.
//  On appelle explicitement Shopify.captcha.protect(form, callback)
//  pour attacher la protection hCaptcha au formulaire, puis on
//  soumet dans le callback (sinon hCaptcha bloque silencieusement).
//  L'iframe caché absorbe la réponse pour éviter toute navigation.
// ───────────────────────────────────────────────────────────────
 
function submitEmail() {
  const input = document.getElementById("emailInput");
  const btn = document.querySelector(".btn-email");
  const success = document.getElementById("emailSuccess");
  const email = input.value.trim();
 
  // Validation simple
  if (!email || !email.includes("@") || !email.includes(".")) {
    input.style.borderColor = "#eb575a";
    input.focus();
    setTimeout(() => { input.style.borderColor = ""; }, 2000);
    return;
  }
 
  btn.disabled = true;
  btn.textContent = "…";
 
  // Tag de profil — ex: "guide|crepu|tres-seche|elevee"
  const profileTag = `guide|${answers[1] || ""}|${answers[2] || ""}|${answers[3] || ""}`;
  const tags = `newsletter,guide-capillaire,${profileTag}`;
 
  // 1. Iframe caché (cible de la soumission, évite la navigation de la page)
  let iframe = document.getElementById("mt-form-target");
  if (!iframe) {
    iframe = document.createElement("iframe");
    iframe.id = "mt-form-target";
    iframe.name = "mt-form-target";
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  }
 
  // 2. Création du formulaire HTML
  const form = document.createElement("form");
  form.method = "POST";
  form.action = "/contact";
  form.target = "mt-form-target";
  form.acceptCharset = "UTF-8";
  form.style.display = "none";
 
  const fields = [
    { name: "form_type", value: "customer" },
    { name: "utf8", value: "✓" },
    { name: "contact[tags]", value: tags },
    { name: "contact[email]", value: email }
  ];
 
  for (const f of fields) {
    const i = document.createElement("input");
    i.type = "hidden";
    i.name = f.name;
    i.value = f.value;
    form.appendChild(i);
  }
 
  // 3. Ajout au DOM
  document.body.appendChild(form);
 
  // 4. Affichage du succès côté utilisatrice (avant la soumission async)
  input.disabled = true;
  success.classList.add("visible");
 
  // 5. Soumission via la chaîne hCaptcha officielle de Shopify.
  //    Shopify.captcha.protect(form, callback) attache hCaptcha au formulaire
  //    et appelle le callback une fois la protection en place.
  const cleanup = () => {
    setTimeout(() => {
      if (form.parentNode) form.parentNode.removeChild(form);
    }, 8000);
  };
 
  const doSubmit = () => {
    try { form.submit(); } catch (e) { console.warn("[Maison Toinon] submit:", e); }
    cleanup();
  };
 
  if (
    window.Shopify &&
    window.Shopify.captcha &&
    typeof window.Shopify.captcha.protect === "function"
  ) {
    try {
      window.Shopify.captcha.protect(form, doSubmit);
    } catch (e) {
      console.warn("[Maison Toinon] captcha.protect failed, fallback submit:", e);
      doSubmit();
    }
  } else {
    // Fallback : API captcha non disponible (peu probable sur Shopify)
    doSubmit();
  }
}
 
// ───────────────────────────────────────────────────────────────
//  REDÉMARRER LE QUIZ
// ───────────────────────────────────────────────────────────────
 
function restart() {
  answers[1] = null;
  answers[2] = null;
  answers[3] = null;
  document.querySelectorAll(".option-card, .option-row").forEach(el => el.classList.remove("selected"));
  document.querySelectorAll(".btn-next").forEach(btn => btn.classList.remove("enabled"));
  const input = document.getElementById("emailInput");
  const success = document.getElementById("emailSuccess");
  if (input) { input.value = ""; input.disabled = false; }
  if (success) success.classList.remove("visible");
  const emailBtn = document.querySelector(".btn-email");
  if (emailBtn) { emailBtn.disabled = false; emailBtn.textContent = "Envoyer →"; }
  goTo(0);
}
 
// ───────────────────────────────────────────────────────────────
//  INITIALISATION
// ───────────────────────────────────────────────────────────────
 
drawHairVisuals();
updateProgress(0);